export default __webpack_public_path__ + "static/media/char_head_prem_010.9f5f494d.png";